import React from 'react'
import { InputInline, SelectAsyncInline } from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'

const ContactInfo = ( {customer, onChange} ) => {
    if (!customer) {
        return null
    }

    return (
      <div className='p-4 space-y-2'>
        <InputInline 
          labelClassName="text-xs"
          label="Address 1"
          placeholder="Address 1"
          disabled={customer.crmIsMaster}
          value={ customer.address }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, address: value })
          }}
        />
  
        <InputInline 
          labelClassName="text-xs"
          label="Address 2"
          placeholder="Address 2"
          disabled={customer.crmIsMaster}
          value={ customer.secondary_address }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, secondary_address: value })
          }}
        />

        <InputInline 
          labelClassName="text-xs"
          label="City"
          placeholder="City"
          disabled={customer.crmIsMaster}
          value={ customer.city }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, city: value })
          }}
        />

        <InputInline 
          labelClassName="text-xs"
          label="Zip"
          placeholder="Zip"
          disabled={customer.crmIsMaster}
          value={ customer.zip }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, zip: value })
          }}
        />

        <SelectAsyncInline
          value={(customer.country?.name) ? { value: customer.country.uid, label: customer.country.name } : null}
          onChange={(selection) => {
            onChange({ ...customer, country: (selection) ? selection.value : null })
          }}
          options={[]}
          label="Country"
          placeholder="Country"
          noOptionsMessage={({ inputValue }) => (inputValue) ? `No country found for '${inputValue}'` : 'No country found'}
          loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
          cacheOptions
          defaultOptions
          isClearable
          disabled={customer.crmIsMaster}
          loadOptions={
            debounce((query) => fetch(`/rest/v1/country?search[name]=${query}`)
              .then((response) => response.json())
              .then((countries) => countries.map(({ uid, name }) => ({ value: uid, label: name })))
            , 250)
          }
        />

        <InputInline 
          labelClassName="text-xs"
          label="EU VAT Id"
          placeholder="EU VAT Id"
          disabled={customer.crmIsMaster}
          value={ customer.euvatid }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, euvatid: value })
          }}
        />

        <InputInline 
          labelClassName="text-xs"
          label="EAN (European Article Number)"
          placeholder="EAN (European Article Number)"
          disabled={customer.crmIsMaster}
          value={ customer.ean }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, ean: value })
          }}
        />

        <InputInline 
          labelClassName="text-xs"
          label="Finance phone"
          placeholder="Finance phone"
          disabled={customer.crmIsMaster}
          value={ customer.phone }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, phone: value })
          }}
        />

        <InputInline 
          labelClassName="text-xs"
          label="Finance email"
          placeholder="Finance email"
          disabled={customer.crmIsMaster}
          value={ customer.email }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, email: value })
          }}
        />

        <InputInline 
          labelClassName="text-xs"
          label="Finance email secondary"
          placeholder="Finance email secondary"
          disabled={customer.crmIsMaster}
          value={ customer.email_secondary }
          onChange={({ target: { value } }) => {
            onChange({ ...customer, email_secondary: value })
          }}
        />
      </div>
    )
}

export default ContactInfo
